import { channelHandlers } from './channels';
import { dialogsHandlers } from './dialogs';
import { knowledgeBaseHandlers } from './knowledge-base';
import { agentTestHandlers } from './agent-test';

export const setEventsHandlers = () => {
  const subscriptions: Array<() => void> = [];

  subscriptions.push(
    ...dialogsHandlers(),
    ...channelHandlers(),
    ...knowledgeBaseHandlers(),
    ...agentTestHandlers(),
  );

  const unsubscribe = () => {
    subscriptions.forEach((unsubscribe) => unsubscribe());
  };

  return unsubscribe;
};
